var BlockProjects = {
	
	mouseX:0,
	mouseY:0,
	
	init:function(){
		
		var _carousel = $(".galerie-slider .galerie");
		
		_carousel.slick({
			arrows:true, 
			dots:false,
			infinite: true,
			variableWidth:true,
			slidesToShow: 1,
			focusOnSelect: true,
			touchThreshold:500,
			prevArrow:"",
			nextArrow:_carousel.parent().find(".arrow-next"),
		});
		
		$(".projet-tease-container").mouseenter(function(){
			BlockProjects.show_thumbnail($(this));
		}).mousemove(function(e){
			
			BlockProjects.mouseX = e.clientX - $(this).offset().left;
			BlockProjects.mouseY = (e.clientY + $(window).scrollTop()) - $(this).offset().top;
			
			$(this).find(".thumbnail-container").css({left:BlockProjects.mouseX, top:BlockProjects.mouseY});
			
		}).mouseleave(function(){
			BlockProjects.hide_thumbnail($(this));
		});
	},
	show_thumbnail:function(pTarget){
		pTarget.addClass("hover");
		pTarget.find(".thumbnail").addClass("visible");
	},
	hide_thumbnail:function(pTarget){
		pTarget.removeClass("hover");
		pTarget.find(".thumbnail").removeClass("visible");		
	}
}

$(window).load(function(){
	if($(".galerie-slider").length){
		BlockProjects.init();
	}
})